import { AccordionVariantType as KubitAccordionVariantType } from '@kubit/web-ui-components/accordionV2/types';
import { AccordionVariantTypeV2 as AccordionVariantType } from '../../../../../../components/accordionV2/types/accordionVariantType';
import { commonStyles } from '../commonStyles';
export const getStandardStyles = (FOUNDATIONS, FONT) => {
    return {
        [AccordionVariantType.STANDARD]: {
            ...commonStyles(FOUNDATIONS, FONT, {
                kubitAccordion: {
                    variant: KubitAccordionVariantType.STANDARD,
                },
            }),
        },
    };
};
//# sourceMappingURL=standard.js.map